export default function getTranslatedRequestTypeList(t: (key: string) => string) {
  return (
    [
      ['customer-support', 'Customer Support'],
      ['sales', 'Talk to Sales'],
      ['partner', 'I am a Partner or Reseller'],
      ['community', 'Community Product and Engagement'],
      ['career', 'Jobs at Sonar'],
      ['marketing', 'Press, Advertising and Sponsorship'],
      ['billing', 'Billing and Payment Information'],
      ['other', 'Other Inquiry'],
    ] as const
  ).map(([value, label]) => ({ value, label: t(`form.${label}`) }));
}
